var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJudgement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 387.25 371.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 192.16,
    y1: 26.45,
    x2: 192.16,
    y2: 344.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 313.59,
    y1: 86.73,
    x2: 192.16,
    y2: 26.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 72.32,
    y1: 86.73,
    x2: 192.16,
    y2: 26.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.8,
    y1: 344.7,
    x2: 366.53,
    y2: 344.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "172.41 37.85 183.45 26.45 172.41 15.05 187.81 18.91 192.16 3.64 196.52 18.91 211.91 15.05 200.87 26.45 211.91 37.85 196.52 34 192.16 49.26 187.81 34 172.41 37.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "172.41 356.1 183.45 344.7 172.41 333.29 187.81 337.15 192.16 321.89 196.52 337.15 211.91 333.29 200.87 344.7 211.91 356.1 196.52 352.24 192.16 367.5 187.81 352.24 172.41 356.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "384.08 329.01 377.64 344.41 385.14 359.32 369.74 352.88 354.83 360.39 361.26 344.98 353.76 330.07 369.17 336.51 384.08 329.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.42 329.01 25.98 344.41 33.48 359.32 18.08 352.88 3.17 360.39 9.61 344.98 2.11 330.07 17.51 336.51 32.42 329.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "328.76 71.57 321.79 86.73 328.76 101.9 313.59 94.93 298.43 101.9 305.4 86.73 298.43 71.57 313.59 78.54 328.76 71.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "328.76 188.74 321.79 203.91 328.76 219.08 313.59 212.1 298.43 219.08 305.4 203.91 298.43 188.74 313.59 195.72 328.76 188.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.48 71.57 80.51 86.73 87.48 101.9 72.32 94.93 57.15 101.9 64.12 86.73 57.15 71.57 72.32 78.54 87.48 71.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.48 188.74 80.51 203.91 87.48 219.08 72.31 212.1 57.15 219.08 64.12 203.91 57.15 188.74 72.31 195.72 87.48 188.74"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudgement);
export default __webpack_public_path__ + "static/media/Judgement.03c3f40e3be3bcb1c5f3021f9d512dbb.svg";
export { ForwardRef as ReactComponent };